module.exports = __webpack_public_path__ + "img/12.2c1ac447.jpg";